import Intercom, * as intercom from '@intercom/messenger-js-sdk'
import { defineNuxtPlugin, useNuxtApp, useRuntimeConfig } from '#app'
import { useCountryConfig } from '~/composables/useCountryConfig'
import { useUserStore } from '~/stores/user'

declare module '#app' {
  // @ts-expect-error For some reason that might throw an error, though it's valid according to the docs
  interface NuxtApp {
    $intercom: typeof intercom
  }
}

export default defineNuxtPlugin(() => {
  const { intercomAppId } = useCountryConfig()
  const { intercomEnabled } = useRuntimeConfig().public
  const { $isDesktop } = useNuxtApp()
  const userStore = useUserStore()

  if (intercomEnabled && $isDesktop()) {
    // Initialize Intercom immediately (may be anonymous if auth not yet loaded)
    Intercom({
      app_id: intercomAppId,
      user_id: userStore.auth?.email,
      email: userStore.auth?.email,
      user_hash: userStore.auth?.intercomHash,
    })

    // Watch for auth changes and update Intercom when user becomes authenticated
    // This handles the hard reload case where auth is loaded asynchronously
    watch(
      () => userStore.auth,
      (auth) => {
        if (auth?.email && auth?.intercomHash) {
          intercom.update({
            email: auth.email,
            user_id: auth.email,
            user_hash: auth.intercomHash,
          })
        }
      },
      { immediate: true },
    )
  }

  return {
    provide: {
      intercom,
    },
  }
})
